import { render } from "./records-type.vue?vue&type=template&id=c8709e30"
import script from "./records-type.vue?vue&type=script&lang=js"
export * from "./records-type.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__